// import React from 'react'
// import { ContactContainer,ContactWrapper, ContactAll, ContactHeading,
// ContactText, MyContact, ContactImage, Image, ContactHead, ContactP} from './ContactElement'
// import {MdEmail, MdLocalPhone, MdLocationOn} from "react-icons/md";
// import img from "../../Images/c4.svg"

// const Contact = () => {
//     return (
//         <ContactContainer id="contact">
//             <ContactHead data-aos="zoom-in">Let's Talk</ContactHead>
//             <ContactP data-aos="zoom-in">Here I have listed my contact informations</ContactP>
//             <ContactWrapper>
//                 <MyContact data-aos="fade-right">
//                 <ContactAll>
//                 <ContactHeading> <MdEmail color="#047aed" fontSize="24px"/> Email</ContactHeading>
//                 <ContactText>  Olawuni50@gmail.com</ContactText>
//                 </ContactAll>

//                 <ContactAll>
//                 <ContactHeading> <MdLocalPhone color="#047aed" fontSize="24px"/> Contact Me</ContactHeading>
//                 <ContactText> +2348118320256, +2348161882454</ContactText>
//                 </ContactAll>

//                 <ContactAll>
//                 <ContactHeading> <MdLocationOn color="#047aed" fontSize="24px"/>Location</ContactHeading>
//                 <ContactText>  Lekki Phase 1 Nigeria</ContactText>
//                 </ContactAll>
//                 </MyContact>

//                 <ContactImage data-aos="fade-left">
//                     <Image src={img} alt="contact"/>
//                 </ContactImage>
                
//             </ContactWrapper>
//         </ContactContainer>
//     )
// }

// export default Contact

import React from "react"
import {Container, Typography, TextField, Button, Divider} from "@mui/material"
import {makeStyles} from "@mui/styles"
import {createTheme} from "@mui/material/styles"
import imgg from "../../Images/contact2.png"
import styled, {keyframes}  from "styled-components"

const Spinner = keyframes`
from{
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    transform:rotateY(0deg);
}
to {
    -moz-transform: rotateY(-360deg);
    -ms-transform: rotateY(-360deg);
    transform: rotateY(-360deg);
}
`

const theme = createTheme()
const useStyles = makeStyles({
    text:{
        display:"flex", 
        flexDirection:"column",
        marginTop:"3rem"
    },

    container:{
        height:"auto", 
    },

    all:{
        display:"flex",
        justifyContent:"space-between",
        [theme.breakpoints.down("sm")]:{
            flexDirection:"column"
        }
    }
})

const Image = styled.img`
/* width:50%; */
border-radius:50%;
width:60%;
height:60%;
animation-name: ${Spinner};
animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
animation-iteration-count: infinite;
animation-duration: 30s;

:hover{
    animation-play-state: paused;
};

@media screen and (max-width: 768px){
    width:auto;
    height:auto;
}

`

const Contact = () =>{
    const classes = useStyles()
    return(
      
        <Container maxWidth="lg" className={classes.container} id="contact">
            <Typography variant="h4" data-aos="zoom-in-down">My Contact</Typography>
            <Divider />
            <div className={classes.all}>
              <div data-aos="fade-right">
            <Typography variant="h6" style={{fontWeight: "bold", marginTop:"1rem"}}> LET'S SAY HI</Typography>
            <Typography variant="h3" style={{marginBottom:"1rem"}}>Hire Me</Typography>
            <Typography variant="h6" style={{marginBottom:"1rem"}}>Call me directly: <span style={{fontWeight: "bold"}}> +2348161882454, +2348118320256</span></Typography>
            <Typography variant="h6">Contact Email: <span style={{fontWeight: "bold"}}> olawuni50@gmail.com</span></Typography>

            <div className={classes.text}>
            <TextField style={{marginBottom:"1.5rem"}} label="Your name" />
            <TextField style={{marginBottom:"1.5rem"}} label="Your Email" type="email" /> 
            <TextField style={{marginBottom:"1.5rem"}} label="Your Subject" /> 
            <TextField label="Your Message" multiline rows={4}/>   

            <Button variant="contained" style={{backgroundColor:"red", marginTop:"2rem", marginBottom:"2rem"}} type="submit">Submit</Button>
            </div>
            </div>
            <Image src={imgg} alt="contact" />
            </div>

        </Container>

    )
}

export default Contact
